import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Grid
} from '@material-ui/core';

import TrafficByDevice from 'src/components/dashboard//TrafficByDevice';
import LoanGen from 'src/components/calculator/App';



import { useState } from 'react';

//Redux
import { useSelector, useDispatch } from "react-redux";
import { SET_CALCULATOR  } from 'src/redux/actions/types';

const Dashboard = () => {
    const [values, setValues] = useState([0, 100, 3100]);
    const [payterm, setPayTerm] = useState([0, 1, 9]);

    const dispatch = useDispatch();
    const { calculator } = useSelector(state => state.data);

    const handleValues = (data) => {
      let vals = values;
      vals[1] = data[0] !== values[0] ? data[0] : data[2] !== values[2] ? data[2] : data[1] === values[0] || data[1] === values[2] ? values[1] : data[1] ;
      setValues(vals);
      dispatch({
        type: SET_CALCULATOR,
        payload: { principal: vals[1] }
      })
    }

    const handlePayTerms = (data) => {
      let vals = payterm;
      vals[1] = data[0] !== payterm[0] ? data[0] : data[2] !== payterm[2] ? data[2] : data[1] === payterm[0] || data[1] === payterm[2] ? payterm[1] : data[1] ;
      setPayTerm(vals);
      dispatch({
        type: SET_CALCULATOR,
        payload: { term: vals[1] }
      })
    }

  return(
  <>
    <Helmet>
      <title>Calculator | Transac</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            lg={8}
            md={12}
            xl={9}
            xs={12}
          >
           <LoanGen/>
          </Grid>
          <Grid
            item
            lg={4}
            md={6}
            xl={3}
            xs={12}
          >
            <TrafficByDevice/>
          </Grid>
        </Grid>
      </Container>
    </Box>
  </>
);
    }

export default Dashboard;
